/**
 * Dashboard Tour Configuration
 */

import { filterExistingSteps } from './tourUtils.js';

export const getDashboardTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="dashboard-verification-level"]',
      content: t('tour.dashboard.verificationLevel', {
        ns: 'common',
        defaultValue: 'Your verification level determines your transaction limits. Higher levels allow larger transactions. Click here to view your verification status and upgrade your level.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="dashboard-wallet-balance"]',
      content: t('tour.dashboard.walletBalance', {
        ns: 'common',
        defaultValue: 'Your total wallet balance available for transactions.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="dashboard-collections"]',
      content: t('tour.dashboard.collections', {
        ns: 'common',
        defaultValue: 'Total money received from invoices and payments.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="dashboard-disbursements"]',
      content: t('tour.dashboard.disbursements', {
        ns: 'common',
        defaultValue: 'Total money sent to recipients.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="dashboard-net-cashflow"]',
      content: t('tour.dashboard.netCashflow', {
        ns: 'common',
        defaultValue: 'Your net cash flow: collections minus disbursements.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="dashboard-chart"]',
      content: t('tour.dashboard.chart', {
        ns: 'common',
        defaultValue: 'Interactive chart showing your financial trends over time.',
      }),
      position: 'top',
    },
    {
      selector: '[data-tour="dashboard-quick-actions"]',
      content: t('tour.dashboard.quickActions', {
        ns: 'common',
        defaultValue: 'Quick access to add money, transfer funds, create invoices, and more.',
      }),
      position: 'top',
    },
    {
      selector: '[data-tour="dashboard-transactions"]',
      content: t('tour.dashboard.transactions', {
        ns: 'common',
        defaultValue: 'View and search all your recent transactions here. Note: Your session automatically expires after 30 minutes of inactivity for security.',
      }),
      position: 'top',
    },
  ]);
